import React, { useState, useEffect, useRef } from 'react';
import MyButton from '../components/UI/button/MyButton';
import { WithWizard } from 'react-albus-react18';
import CustomRadio from '../components/UI/radio/CustomRadio';
import { TypeAnimation } from 'react-type-animation';
import CustomTitle from '../components/UI/title/CustomTitle';
import { useHistory } from 'react-router-dom';
import useMixpanel from '../hooks/useMixpanel';
import { useHandleRedirect } from '../hooks/useHandleRedirect';
import { useDispatch, useSelector } from 'react-redux';
import { setButtonClick } from '../store/buttonSlice';

const Sell = ({ setButtonText, setError, error, selectedOption, setSelectedOption, setButtonShow, setButtonTime, buttonStatus, setButtonStatus, setEventProperties, sessionId, setEventName }) => {
    const history = useHistory();

    useEffect(() => {
        if (setButtonText) {
            setButtonText('Continue')
        }
        if (setButtonShow) {
            setButtonShow(false);
        }
        if (setButtonTime) {
            setButtonTime(150);
        }

        setSelectedOption(null)

        if (buttonStatus == 'Summary') {
            setButtonText('Save');
        }
        if (setEventName) {
            setEventName('web_products_type')
        }

    }, []);




    const initialCheckboxState = [
        {
            id: 'option1',
            checked: false,
            text: "Products",
            img: 'product1.webp',
            text1: "You're in high-performing hands!",
            text2: "We've successfully boosted sales for businesses like yours with creatives and online ads.",
            productType: 'PRODUCT'
        },
        {
            id: 'option2',
            checked: false,
            text: "Services",
            img: 'product2.webp',
            text1: "You've made a great choice!",
            text2: "Our tools effectively help digital products increase their sales through creatives and online ads.",
            productType: 'SERVICE'
        },
        // {
        //     id: 'option3',
        //     checked: false,
        //     text: "Dropshipping products",
        //     img: 'sell3.png',
        //     text1: "Dropshippers love our creatives!",
        //     text2: "Many dropshippers have experienced growth using our creatives and online ads.",
        //     productType: 'PRODUCT'
        // },
        {
            id: 'option4',
            checked: false,
            text: "Both",
            img: 'product3.webp',
            text1: "You came to the right place!",
            text2: "Businesses in the service sector see a substantial increase in sales after using our ads.",
            productType: 'SERVICE'
        },
    ];

    // useEffect(() => {
    //     const storedSellValue = localStorage.getItem('sellId');
    //     if (storedSellValue) {
    //         setSelectedOption(storedSellValue);
    //         const selectedOption = initialCheckboxState.find(option => option.id === storedSellValue);
    //         const selectedOptionText = selectedOption ? selectedOption.text : "";
    //         if (setEventProperties) {
    //             setEventProperties({
    //                 session_id: sessionId,
    //                 web_entrance: 'signup',
    //                 web_product_type: selectedOptionText
    //             })
    //         }

    //     }
    // }, []);

    const { trackEvent } = useMixpanel();

    const dispatch = useDispatch();

    const handleCheckboxChange = (checkbox) => {
        var profilesJSON = localStorage.getItem('business-profiles');
        localStorage.setItem('direction', checkbox.productType);
        if (profilesJSON) {
            var profiles = JSON.parse(profilesJSON);
            profiles.forEach(function (profile) {
                profile.productsType = checkbox.text;
                profile.direction = checkbox.productType;
            });
            var updatedProfilesJSON = JSON.stringify(profiles);
            localStorage.setItem('business-profiles', updatedProfilesJSON);
        } else {
            var newProfile = {
                productsType: checkbox.text,
                direction: checkbox.productType
            };
            var newProfiles = [newProfile];
            var newProfilesJSON = JSON.stringify(newProfiles);
            localStorage.setItem('business-profiles', newProfilesJSON);
        }
        if (setEventProperties) {
            setEventProperties({
                session_id: sessionId,
                web_entrance: 'signup',
                web_product_type: checkbox.text
            })
        }

        setSelectedOption(checkbox.text);
        localStorage.setItem('sellId', checkbox.id);
        localStorage.setItem('sell', checkbox.text);



        setTimeout(() => {
            dispatch(setButtonClick(true))
        }, 350);

    };


    const { handleRedirectClick } = useHandleRedirect();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);

    useEffect(() => {
        if (buttonClicked) {
            handleRedirectClick(
                '',
                '',
                'web_products_type',
                {
                    web_products_type: selectedOption,
                }
            );
        }

    }, [buttonClicked, selectedOption]);




    return (
        <div style={{ paddingBottom: "0rem" }} className="sell-page">
            <CustomTitle style={{ marginBottom: "24rem" }} title={'What do you sell?'} />
            {initialCheckboxState.map((checkbox, index) => (
                <CustomRadio
                    key={checkbox.id}
                    id={checkbox.id}
                    checked={selectedOption === checkbox.text}
                    onChange={() => handleCheckboxChange(checkbox)}
                    className={error ? 'error' : undefined}
                    style={{ marginBottom: index === initialCheckboxState.length - 1 ? '0rem' : '20rem' }}
                >
                    <img src={process.env.REACT_APP_BASENAME + `/img/${checkbox.img}`} alt="" />
                    {checkbox.text}
                </CustomRadio>
            ))}


        </div>
    );
}

export default Sell;
